import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './pollpage.css';
import { useDispatch, useSelector } from 'react-redux';
import {  getPollFetchData } from '../../../redux/actions/getPollAction';
import { PollVoteFetchData } from '../../../redux/actions/PollVoteAction';

// Dynamic cookie key will be used: sandesh_poll_id_{id}

const PollPage = () => {
  const [showPoll, setShowPoll] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [resultsVisible, setResultsVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVoted, setIsVoted] = useState(false);

  const dispatch = useDispatch();
  const getPollReducer = useSelector((state) => state?.getPollReducer.data);
  const pollData = getPollReducer?.data || getPollReducer;

  useEffect(() => {
    dispatch(getPollFetchData());
  }, [dispatch]);

  useEffect(() => {
    if (!pollData?.id) return;

    const pollId = pollData.id;
    const pollCookieKey = `sandesh_poll_id_${pollId}`;
    const pollStatus = Cookies.get(pollCookieKey);
    
    // Check if user has already interacted with THIS specific poll
    if (!pollStatus) {
      // Small delay for better user experience after page load
      const timer = setTimeout(() => {
        setShowPoll(true);
        // Automatically mark as viewed/shown so it doesn't repeat on navigation for this ID
        Cookies.set(pollCookieKey, "viewed", { expires: 1 });
      }, 2000);
      return () => clearTimeout(timer);
    } else if (pollStatus === "voted") {
        // If they voted, we previously showed it, but "once only" means we might want to hide it
        // However, if we want to allow them to see results, we could show it.
        // Based on "ek user ne ek j var poll display thavo joiye", we'll keep it hidden if already interacted with.
        setIsVoted(true);
        setResultsVisible(true);
        setShowPoll(false); 
    } else {
        // "dismissed" or "viewed" - don't show automatically
        setShowPoll(false);
    }
  }, [pollData?.id]);

  const handleClose = () => {
    setShowPoll(false);
    if (pollData?.id) {
      const pollCookieKey = `sandesh_poll_id_${pollData.id}`;
      // Set cookie even if they just close it, so it doesn't pop up again for this poll
      Cookies.set(pollCookieKey, "dismissed", { expires: 30 });
    }
  };

 
  const handleVote = () => {
    if (!selectedId) return;
    setIsSubmitting(true);
    
    const pollId = pollData?.id || 1;
    const selectedOption = pollData?.options?.[selectedId - 1];
    
    if (!selectedOption) {
      console.error("Selected option not found");
      setIsSubmitting(false);
      return;
    }
    
    dispatch(PollVoteFetchData(pollId, selectedOption))
      .then((res) => {
        setIsSubmitting(false);
        setIsVoted(true);
        setResultsVisible(true);
        
        // Mark as voted in cookies with the specific poll ID
        const pollCookieKey = `sandesh_poll_id_${pollId}`;
        Cookies.set(pollCookieKey, "voted", { expires: 365 });
        
        // Auto-close after 4 seconds of displaying thanks
        setTimeout(() => {
          setShowPoll(false);
        }, 4000);
      })
      .catch((err) => {
        console.error("Error submitting vote:", err);
        setIsSubmitting(false);
        // Optionally show an UI error here
      });
  };

  // Fallback data for testing if API is not yet returning data
  
  // pollData is now defined above with the useEffect
  // const pollData = getPollReducer?.data || getPollReducer;

  // Split question into title and description if possible
  const questionParts = pollData?.question ? pollData.question.split(/\r?\n\r?\n/) : [];
  const pollTitle = "સંદેશ ન્યૂઝ Poll";
  const pollDesc = questionParts.slice(1).join("\n") || pollData?.question;

  // Parse votes and calculate percentages
  let votesData = {};
  try {
    if (pollData?.votes) {
      votesData = typeof pollData.votes === 'string' 
        ? JSON.parse(pollData.votes) 
        : pollData.votes;
    }
    console.log(votesData, "votesData");
  } catch (error) {
    console.error("Error parsing poll votes:", error);
  }
  
  const totalVotes = Object.values(votesData).reduce((sum, val) => sum + Number(val), 0);
  
  const pollOptions = pollData?.options?.map((option, index) => {
    const voteKey = option;
    const voteCount = Number(votesData[voteKey] || 0);
    const percent = totalVotes > 0 ? Math.round((voteCount / totalVotes) * 100) : 0;
    console.log(percent,"percent");
    
    return {
      id: index + 1,
      name: option,
      percent: percent,
      votes: voteCount
    };
  }) || [];

  if (!showPoll) return null;

  return (
    <div className="poll-modal-overlay" onClick={(e) => e.target.className === 'poll-modal-overlay' && handleClose()}>
      <div className="poll-container">
        <div className="glass-card">
          {/* Close button */}
          <button className="poll-close-btn" onClick={handleClose} aria-label="Close poll">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          
          <div className="poll-header">
            <h1 className="gujarati-text">{pollTitle}</h1>
            <p className="gujarati-text" style={{fontStyle:"bold"}}>{pollDesc}</p>
          </div>

          <div className="candidate-list">
            {pollOptions.map((opt) => (
              <div 
                key={opt.id}
                className={`candidate-card ${selectedId === opt.id ? 'selected' : ''}`}
                onClick={() => !resultsVisible && setSelectedId(opt.id)}
              >
                <div className="candidate-info">
                  <div className="results-header">
                    <span className="candidate-name gujarati-text">{opt.name}</span>
                    {resultsVisible && <span className="vote-percent">{opt.percent}%</span>}
                  </div>
                  
                  {resultsVisible && (
                    <div className="progress-bar-container">
                      <div 
                        className="progress-fill" 
                        style={{ width: `${opt.percent}%` }}
                      ></div>
                    </div>
                  )}
                </div>
                {selectedId === opt.id && (
                    <div className="check-badge">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                )}
              </div>
            ))}
          </div>

          <div className="poll-actions">
            {!isVoted ? (
              <>
                <button 
                  className="btn-vote" 
                  disabled={!selectedId || isSubmitting}
                  onClick={handleVote}
                >
                  {isSubmitting ? (
                    <div className="poll-spinner"></div>
                  ) : (
                    "Submit My Vote"
                  )}
                </button>
                <button 
                  className="btn-view-results"
                  onClick={() => setResultsVisible(!resultsVisible)}
                >
                  {resultsVisible ? "Hide current results" : "view current results"}
                </button>
              </>
            ) : (
              <div className="thank-you-msg">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#10B981" fillOpacity="0.2"/>
                    <path d="M8 12L11 15L16 9" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Your vote has been recorded securely!</span>
              </div>
            )}
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default PollPage;